import { decryptStr, resetForm } from "@/helpers/helper";
import { useToast } from "vue-toastification";

const toast = useToast();
import axios from "axios";
import router from "@/router"; // Make sure this points to your router file
const BASE_URL = window.location.origin;
const API_BASE_URL = "https://granary.be.favitech.co.ke/api/v1/";

let BACKEND_URL = "";
let toastShown = false;

const http = () => {
  const apiClient = axios.create({
    baseURL: resolveUrl(BASE_URL),
    withCredentials: true,
    validateStatus: (status) => status >= 200 && status < 300,
  });



  // Response interceptor to handle 401 errors globally
  apiClient.interceptors.response.use(
    (response) => response,
    (error) => {
      console.log("Error", error);
      if (error.response && error.response.status == 401) {
        localStorage.removeItem("granary_capital");
        if (!toastShown) {
          toast.error("Your session has expired. Please log in again.");
          toastShown = true;
          setTimeout(() => {
            toastShown = false;
          }, 5000); // reset after 5s
        }
        // Redirect to login, with optional redirect back
        const currentRoute = router.currentRoute.value;
      }
      return Promise.reject(error);
    }
  );
  return apiClient;
};

export const resolveUrl = (origin) => {
  switch (origin) {
    case "https://sso.favitech.co.ke":
    case "https://test.favitech.co.ke":
    case "https://test.kredicore.favitech.co.ke":
    case "https://portal.favitech.co.ke":
    case "https://accounts.favitech.co.ke":
    case "https://granary.be.favitech.co.ke":
    case "https://granarytest.favitech.co.ke":
    case "https://sso.granary.favitech.co.ke":
    case "https://accountsgranary.favitech.co.ke":
    case "https://hr.granary.favitech.co.ke":
      return API_BASE_URL;
    case "http://localhost:5173":
    case "http://localhost:5174":
    case "http://localhost:5175":
    case "http://localhost:5176":
    case "http://localhost:5177":
    case "http://localhost:5178":
    case "http://localhost:5179":
      return "http://localhost:8000/api/v1/";
    default:
      return API_BASE_URL;
  }
};
export default http;
